import styled, { withTheme } from 'styled-components';

const HiddenMdDown = styled.div`
  width: 100%;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`;

export default withTheme(HiddenMdDown);
